import { FullPattern } from '../core-data-model/Pattern.model';
import { ReferencePatternType } from './ReferencePatternType.model';

export class BehavioralReportData {
    piLanguageLocale: string;
    surveyTakerName: string;
    firstName: string;
    lastName: string;
    dateTaken: string;
    reportSummary: string;
    strongestBehaviorIntro: string;
    strongestBehaviorHeader: string;
    strongestBehaviorContents: string[];
    influencingTexts: string;
    managementTexts: string;
    sellingTexts: string;
    managementStyleIntro: string;
    influencingStyleIntro: string;
    sellingStyleIntro: string;
    managementStrategyTexts: string;
    managementStrategyIntro: string;
    gender: string;
    isManagementStyle: boolean;
    isSellingStyle: boolean;
    isInfluencingStyle: boolean;
    createdByUserId: number;
    referencePattern: ReferencePatternType;
    referencePatternName: string;
    referencePatternDescription: string;
    // patternData details
    patternDataForReportGen: FullPattern;

    constructor(startingValues?: any) {
        Object.assign(this, startingValues);
    }
}
